module.exports = __webpack_public_path__ + "img/myanmar.5d9d46bc.svg";